/**
 * VIB-1290: pure helpers for kundekortet. Holdt utenfor hooken (som er en ren
 * orkestrator) så de kan unit-testes uten React Query / Supabase-mock.
 */

/**
 * Slå sammen fakturaer hentet via to kilder (kundens prosjekter +
 * kundens avtaler) og dedupliser på id. En avtale-faktura kan i prinsippet
 * også være koblet til et prosjekt, så samme rad kan komme fra begge
 * spørringene — vi vil bare vise den én gang.
 */
export function dedupInvoicesById<T extends { id: string }>(...sources: T[][]): T[] {
  const byId = new Map<string, T>();
  for (const source of sources) {
    for (const inv of source) {
      if (!byId.has(inv.id)) byId.set(inv.id, inv);
    }
  }
  return Array.from(byId.values());
}
